import React from 'react';
import ImportMain from '../7-import/Import_main';

const ImportDevis: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <ImportMain />
    </div>
  );
};

export default ImportDevis;
